const passwordSuccessMessage = document.querySelector(".password_success_message");
const passwordErrorMessage = document.querySelector(".password_error_message");
const SHOPIFY_STOREFRONT_TOKEN = document.getElementById('customer-email').dataset.token;
const SHOPIFY_STOREFRONT_GRAPHQL = `https://${window.location.hostname}/api/2023-07/graphql.json`;

export async function updatePassword() {
    const newPassword = document.getElementById('new_password').value;
    const accessToken = window.localStorage.getItem("ShopifyCustomerToken");
    
    if (!accessToken) {
      console.error('Customer access token is missing');
      return;
    }
    
    const mutation = `
        mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
        customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
            customer {
                id
            }
            customerUserErrors {
                code
                field
                message
            }
        }
        }
    `;
    
    const response = await fetch(`${SHOPIFY_STOREFRONT_GRAPHQL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT_TOKEN,
      },
      body: JSON.stringify({
        query: mutation,
        variables: {
          customerAccessToken: accessToken,
          customer: {
            password: newPassword,
          },
        },
      }),
    });
    
    const data = await response.json();
    if (data.errors || data.data.customerUpdate.customerUserErrors.length) {
        passwordSuccessMessage.classList.remove("active");
        passwordErrorMessage.classList.add("active");
        if (data.data.customerUpdate.customerUserErrors.length) {
            passwordErrorMessage.textContent = data.data.customerUpdate?.customerUserErrors[0]?.message;
        }
    } else {
        passwordErrorMessage.classList.remove("active");
        passwordSuccessMessage.classList.add("active");
    }
}